import React from 'react'
/* import Reseau from '../Data/reseau.json'*/
function Footer() {
	return (
		<footer className="footer" id="contact">
			<div className="container">
				<div className="footer-top">
					<div className="footer-brand">
						<a href="#home" className="logo">
							Avenir +
						</a>

						<p className="section-text">
						Avenir + est un organisme de perfectionnement scolaire pour les enfants de la maternelle au lycée.
						</p>

{/* 						<ul className="social-list">
							{Reseau.map((content, i) => (
								<li key={content?.id}>
									<a
										href={content?.link}
										target="_blank"
										rel="noopener noreferrer"
										className="social-link"
									>
										<ion-icon name={content?.icon}></ion-icon>
									</a>
								</li>
							))}
						</ul> */}
					</div>

					<ul className="footer-list">
						<li>
							<p className="footer-list-title">Nous Contacter</p>
						</li>

						<li className="footer-item">
							<ion-icon name="location-outline" aria-hidden="true"></ion-icon>

							<address className="footer-link">12 rue du Petit Parc 77150 LESIGNY</address>
						</li>

						<li className="footer-item">
							<ion-icon name="call" aria-hidden="true"></ion-icon>

							<a href="tel:+33614170145" className="footer-link">
								06 14 17 01 45
							</a>
						</li>

						<li className="footer-item">
							<ion-icon name="mail-outline" aria-hidden="true"></ion-icon>

							<a href="mailto:coursavenirplus@hotmail.com" className="footer-link">
								coursavenirplus@hotmail.com
							</a>
						</li>
					</ul>
				</div>

				<div className="footer-bottom">
					<p className="copyright">Copyright 2023 Avenir +. Tous droits réservés</p>
				</div>
			</div>
		</footer>
	)
}

export default Footer
